import type { FC } from 'react';

import { Button } from 'components/Button/Button';
import { OverlayModal } from 'components/OverlayModal/OverlayModal';
import { OverlayModalBody } from 'components/OverlayModal/OverlayModalBody';
import { OverlayModalFooter } from 'components/OverlayModal/OverlayModalFooter';
import { OverlayModalHeader } from 'components/OverlayModal/OverlayModalHeader';
import { useLocale } from 'containers/App/LocaleContext';
import { EulaText } from './EulaText';

export const EulaModal: FC<{ onClose: () => void }> = (props) => {
  const { onClose } = props;
  const {
    auth: { eula: msg },
  } = useLocale();

  return (
    <OverlayModal
      onClose={onClose}
      size='content-default'
      contentClassName='flex flex-col flex-1'
    >
      <OverlayModalHeader>
        <h4 className='box-title'>{msg.title}</h4>
      </OverlayModalHeader>
      <OverlayModalBody className='cross-browser-scrollbar flex-1 overflow-auto'>
        <EulaText />
      </OverlayModalBody>
      <OverlayModalFooter>
        <Button type='button' variant='secondary' onClick={onClose}>
          {msg.btnClose}
        </Button>
      </OverlayModalFooter>
    </OverlayModal>
  );
};
